"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const uuid_1 = require("uuid");
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function IconsEditorTextcolorSvg(props) {
    const id0 = (0, react_1.useMemo)(() => (0, uuid_1.v4)(), []);
    const id1 = (0, react_1.useMemo)(() => (0, uuid_1.v4)(), []);
    return react_1.default.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 16, height: 16, viewBox: "0 0 16 16" }, props),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("path", { id: `iconseditortextcolor-${id0}`, d: "M0 0H12V2H0z" }),
            react_1.default.createElement("path", { id: `iconseditortextcolor-${id1}`, d: "M4.295 12l.833-2.193h5.202L11.163 12h2.261L8.97.661H6.488L2.034 12h2.261zm5.474-3.944h-4.08l2.04-5.406 2.04 5.406z" })),
        react_1.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("g", null,
                react_1.default.createElement("g", null,
                    react_1.default.createElement("g", null,
                        react_1.default.createElement("g", { transform: "translate(-1799 -149) translate(1593 136) translate(192) translate(14 13)" },
                            react_1.default.createElement("path", { fillRule: "nonzero", d: "M0 0H16V16H0z" }),
                            react_1.default.createElement("g", { transform: "translate(2 13)" },
                                react_1.default.createElement("mask", { id: "xmx3e4e2zb", fill: "#fff" },
                                    react_1.default.createElement("use", { xlinkHref: `#iconseditortextcolor-${id0}` })),
                                react_1.default.createElement("use", { fill: "#383F49", xlinkHref: `#iconseditortextcolor-${id0}` }),
                                react_1.default.createElement("path", { fill: "#283F88", d: "M0 -1H2V3H0z", mask: "url(#xmx3e4e2zb)" }),
                                react_1.default.createElement("path", { fill: "#597EFF", d: "M2 -1H4V3H2z", mask: "url(#xmx3e4e2zb)" }),
                                react_1.default.createElement("path", { fill: "#18C7C9", d: "M4 -1H6V3H4z", mask: "url(#xmx3e4e2zb)" }),
                                react_1.default.createElement("path", { fill: "#6EE59A", d: "M6 -1H8V3H6z", mask: "url(#xmx3e4e2zb)" }),
                                react_1.default.createElement("path", { fill: "#FFDD0F", d: "M8 -1H10V3H8z", mask: "url(#xmx3e4e2zb)" }),
                                react_1.default.createElement("path", { fill: "#FF6161", d: "M10 -1H12V3H10z", mask: "url(#xmx3e4e2zb)" })),
                            react_1.default.createElement("mask", { id: "2zkltambgd", fill: "#fff" },
                                react_1.default.createElement("use", { xlinkHref: `#iconseditortextcolor-${id1}` })),
                            react_1.default.createElement("use", { fill: "#24272B", fillRule: "nonzero", xlinkHref: `#iconseditortextcolor-${id1}` }),
                            react_1.default.createElement("g", { fill: "#383F49", mask: "url(#2zkltambgd)" },
                                react_1.default.createElement("path", { d: "M0 0H16V16H0z" }))))))));
}
function IconsEditorTextcolor(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(IconsEditorTextcolorSvg, Object.assign({}, svgProps)));
}
exports.default = IconsEditorTextcolor;
//# sourceMappingURL=IconsEditorTextcolor.js.map